import React from 'react';
import PropTypes from 'prop-types';
import { Card, CardBody, Button } from 'reactstrap';

const CardService = ({ media,tech, image, path,git, title, description, children }) => (
  <Card className="card-span h-100">
    <div className='row'>
      <div className="card-span-img col">
        <img src={media.icon} alt='Tech Icon' width='50'/>
      </div>
    </div>
    
    <CardBody className="pt-6 pb-4">
      <h5 className="mb-2">{title}</h5>
      {description && <p>{description}</p>}
      {children}
      <h5 className="mb-2">Tech Stack</h5>
      { tech && tech.map( (title) => <span class="badge badge-info mr-2">{title}</span>)}
      <img src={image} alt='Live image' className='w-100 mt-3'/>
      {path && <a className='mt-3 btn btn-info ' href={path} >Live View</a>}
      {git && <a className='mt-3 btn btn-info  ml-3' href={git} > Github</a>}
    </CardBody>
  </Card>
);

CardService.propTypes = {
  media: PropTypes.shape({
    icon: PropTypes.oneOfType([PropTypes.array, PropTypes.string]).isRequired,
    color: PropTypes.string.isRequired,
    className: PropTypes.string
  }),
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  children: PropTypes.node
};

export default CardService;
